import { v4 as uuidv4 } from 'uuid';

export const summarizeSolutions = (equipments, usages, solutions) => {
    let summary = [];
    
    equipments.forEach(equipment => {
        let equipmentType = equipment.type_equipment;
        
        let toAdd = {
            equipment_id: equipment._id,
            equipment_type: equipmentType,
            location: equipment.location,
            equipment_initial_water_value: equipment.water_value,
            equipment_initial_water_value_unit: equipment.water_value_unit,
            usages: [],
            solutions: []
        };
        
        usages.forEach(usage => {
            if (usage._id_equipement === equipment._id) {
                let usageEntry = { 
                    ...usage, 
                    solutions: [], 
                    equipment_id: equipment._id, 
                    location: equipment.location,
                    equipment_type: equipmentType, // Add equipment_type to usage entry
                    machine_type: equipment.technical_data?.type_machine || null // Add machine_type to usage entry if available
                };
                
                solutions.forEach(solution => {
                    if (solution.type_solution === "usage" && solution.type_equipment === "machine" && solution.type_equipment === equipmentType && (solution.type_usage === usage.type_usage || solution.type_usage === "all")) {
                        if (equipment.technical_data.type_machine === solution.type_machine){
                            usageEntry.solutions.push({
                                solution_name: solution.name_solution,
                                solution_id: uuidv4(),
                                is_solution_active : false,
                                usage_type: usage.type_usage,
                                machine_type: solution.type_machine,
                                not_drinkable_water_possibility_in_entry: solution.not_drinkable_water_possibility_in_entry,
                                scope_of_works: solution.scope_of_works,
                                water_savings: solution.water_savings,
                                water_savings_unit: solution.water_savings_unit,
                                price: solution.price,
                                description: solution.description
                            });
                        }
                    }

                    else if (solution.type_solution === "usage" && solution.type_equipment === equipmentType && (solution.type_usage === usage.type_usage || solution.type_usage === "all")) {
                        usageEntry.solutions.push({
                            solution_name: solution.name_solution,
                            solution_id: uuidv4(),
                            is_solution_active : false,
                            usage_type: solution.type_usage,
                            machine_type: solution.type_machine,
                            not_drinkable_water_possibility_in_entry: solution.not_drinkable_water_possibility_in_entry,
                            scope_of_works: solution.scope_of_works,
                            water_savings: solution.water_savings,
                            water_savings_unit: solution.water_savings_unit,
                            price: solution.price,
                            description: solution.description
                        });
                    }
                });
                
                toAdd.usages.push(usageEntry);
            }
        });
        
        solutions.forEach(solution => {
            if (solution.type_solution === "equipment" && equipmentType === 'machine' && solution.type_equipment === equipmentType) {
                if (equipment.technical_data.type_machine === solution.type_machine){ // pour les machines, on vérifie que le type de machine correspond à la solution proposée !
                    toAdd.solutions.push({
                        solution_name: solution.name_solution,
                        solution_id: uuidv4(),
                        is_solution_active: false,
                        usage_type: solution.type_usage,
                        machine_type: solution.type_machine,
                        not_drinkable_water_possibility_in_entry: solution.not_drinkable_water_possibility_in_entry,
                        scope_of_works: solution.scope_of_works,
                        water_savings: solution.water_savings,
                        water_savings_unit: solution.water_savings_unit,
                        price: solution.price,
                        description: solution.description
                    });
                }
            }
            else if (solution.type_solution === "equipment" && solution.type_equipment === equipmentType) {
                toAdd.solutions.push({
                    solution_name: solution.name_solution,
                    solution_id: uuidv4(),
                    is_solution_active: false,
                    usage_type: solution.type_usage,
                    machine_type: solution.type_machine,
                    not_drinkable_water_possibility_in_entry: solution.not_drinkable_water_possibility_in_entry,
                    scope_of_works: solution.scope_of_works,
                    water_savings: solution.water_savings,
                    water_savings_unit: solution.water_savings_unit,
                    price: solution.price,
                    description: solution.description
                });
            }
        });
        
        summary.push(toAdd);
    });
    
    // Ajout des solutions de type "all" séparément dans un équipement générique "all"
    let allEquipmentEntry = {
        equipment_id: "0",
        equipment_type: "all",
        location: {
            name_building : " ",
            name_section : " ",
            name_room : " "
        },
        solutions: []
    };

    solutions.forEach(solution => {
        if (solution.type_solution === "equipment" && solution.type_equipment === "all") {
            allEquipmentEntry.solutions.push({
                solution_name: solution.name_solution,
                solution_id: uuidv4(),
                is_solution_active: false,
                usage_type: solution.type_usage,
                machine_type: solution.type_machine,
                not_drinkable_water_possibility_in_entry: solution.not_drinkable_water_possibility_in_entry,
                scope_of_works: solution.scope_of_works,
                water_savings: solution.water_savings,
                water_savings_unit: solution.water_savings_unit,
                price: solution.price,
                description: solution.description
            });
        }
    });

    if (allEquipmentEntry.solutions.length > 0) {
        summary.push(allEquipmentEntry);
    }
    return summary;
};

export const transformSolutions = (summary) => {
    let transformed = {
        equipments: [],
        usages: []
    };

    if (!summary || !Array.isArray(summary)) {
        return transformed;
    }

    summary.forEach(equipment => {
        if (Array.isArray(equipment.solutions)) {
            equipment.solutions.forEach(solution => {
                transformed.equipments.push({
                    equipment_id: equipment.equipment_id,
                    equipment_type: equipment.equipment_type,
                    location: equipment.location,
                    equipment_initial_water_value: equipment.equipment_initial_water_value || null,
                    equipment_initial_water_value_unit: equipment.equipment_initial_water_value_unit || null,
                    ...solution
                });
            });
        }

        if (Array.isArray(equipment.usages)) {
            equipment.usages.forEach(usage => {
                if (Array.isArray(usage.solutions)) {
                    usage.solutions.forEach(solution => {
                        transformed.usages.push({
                            usage_id: usage._id_equipement,
                            usage_type: usage.type_usage,
                            equipment_id: usage.equipment_id,
                            location: usage.location,
                            equipment_type: usage.equipment_type, // Add equipment_type to transformed usage
                            machine_type: usage.machine_type, // Add machine_type to transformed usage if available
                            ...solution
                        });
                    });
                }
            });
        }
    });

    return transformed;
};

